import { useState, type VoidFunctionComponent } from 'react';

import type { SetState } from '../../../../types';
import type { ProjectTypes } from '../shared/types';

import Filter from './shared/components/Filter';
import { ReportCategories } from './utils';
import type { OnApply } from './shared/components/Filter';
import type { FormatSelection } from './shared/components/FormatSelect';
import type { DependencyMetadataFilterOption, FormatName, IncludeFilterOption, SBOMFormat } from './shared/types';

type SBOMFiltersProps = {
  onApply: OnApply;
  appliedFormat: FormatName | null;
  includeOptions: IncludeFilterOption[];
  dependencyMetadataOptions: DependencyMetadataFilterOption[];
  setIsDirty: SetState<boolean>;
  isApplyButtonDisabled: boolean;
  projectType: ProjectTypes;
  // SBOM fields
  authorName: string;
  authorEmail: string;
  supplier: string;
};

const SBOMFilters: VoidFunctionComponent<SBOMFiltersProps> = ({
  onApply,
  appliedFormat,
  includeOptions,
  dependencyMetadataOptions,
  setIsDirty,
  isApplyButtonDisabled,
  authorName,
  authorEmail,
  supplier,
  projectType,
}) => {
  const spdxFormat: SBOMFormat = { label: 'SPDX', value: 'SPDX' };
  const formats: SBOMFormat[] = [
    spdxFormat,
    { label: 'SPDX (JSON)', value: 'SPDX (JSON)' },
    { label: 'CycloneDX (JSON)', value: 'CycloneDX (JSON)' },
    { label: 'CycloneDX (XML)', value: 'CycloneDX (XML)' },
  ];
  const [format, setFormat] = useState<FormatSelection>(spdxFormat);
  return (
    <Filter
      isApplyButtonDisabled={isApplyButtonDisabled}
      setIsDirty={setIsDirty}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      category={ReportCategories.SBOM}
      appliedFormat={appliedFormat}
      format={format}
      setFormat={setFormat}
      formats={formats}
      onApply={onApply}
      authorName={authorName}
      authorEmail={authorEmail}
      supplier={supplier}
      projectType={projectType}
    />
  );
};

export default SBOMFilters;
